var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutocompleteResultPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.93753C8 6.29033 6 8.06452 4 10C2 8.06452 0 6.29033 0 3.93753C0 1.58474 1.79086 0 4 0C6.20914 0 8 1.58474 8 3.93753Z",
    fill: "#52D0CF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.99984,
    cy: 3.99984,
    r: 1.33333,
    fill: "#1C1C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutocompleteResultPin);
export default __webpack_public_path__ + "static/media/autocomplete_result_pin.da1f04998569c7cf9a2a502a29877b97.svg";
export { ForwardRef as ReactComponent };